import React from 'react';
import './Services.css';

function Services() {
  const services = [
    {
      icon: '🌐',
      title: 'Web Application Development',
      description: 'Custom web applications built with modern technologies like React, Angular, Node.js, and PHP. We create scalable, secure, and user-friendly solutions tailored to your business needs.',
      features: ['Custom Web Apps', 'E-commerce Solutions', 'CMS Development', 'API Integration']
    },
    {
      icon: '📱',
      title: 'Mobile App Development',
      description: 'Native and cross-platform mobile applications for iOS and Android. We build intuitive, high-performance apps that engage users and drive results.',
      features: ['iOS Development', 'Android Development', 'React Native', 'Flutter Apps']
    },
    {
      icon: '💼',
      title: 'IT Consultancy',
      description: 'Strategic technology consulting to help you make informed decisions. We analyze your business needs and recommend the best solutions for growth.',
      features: ['Technology Assessment', 'Digital Strategy', 'System Architecture', 'Process Optimization']
    },
    {
      icon: '☁️',
      title: 'Cloud Solutions',
      description: 'Cloud infrastructure setup, migration, and management services. We help you leverage the power of cloud computing for scalability and cost efficiency.',
      features: ['AWS Services', 'Azure Solutions', 'Cloud Migration', 'DevOps']
    }
  ];

  return (
    <section id="services" className="services">
      <div className="container">
        <div className="section-header">
          <h2>Our Services</h2>
          <div className="underline"></div>
          <p className="section-subtitle">
            Comprehensive IT solutions to power your business forward
          </p>
        </div>
        
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">{service.icon}</div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              <ul className="service-features">
                {service.features.map((feature, idx) => (
                  <li key={idx}>{feature}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;
